import { Component, OnInit, ViewEncapsulation, SimpleChanges, OnChanges, ElementRef, ViewChild, Input } from '@angular/core';

import { Observable } from 'rxjs';

import { NumberValidator } from '../../../utils/validation/number.validator';
import { RegexValidator } from '../../../utils/validation/regex.validator';
import { BaseVraagControlDirective } from '../base/base-vraag-control';
import { Antwoord, Vraag } from '@models/claims';
import { IBaseVraagboomResultaat, VraagboomAntwoord, VraagboomNumberResultaat } from '@models/vragenboom';
import { DataService } from '@components/public_api';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-decimal',
  templateUrl: './decimal.component.html',
  styleUrls: ['./decimal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DecimalComponent extends BaseVraagControlDirective<VraagboomNumberResultaat> implements OnInit, OnChanges {
  resultaat: VraagboomNumberResultaat = new VraagboomNumberResultaat();
  @ViewChild('decimalField', { static: true }) decimalElement: ElementRef;
  @Input() isCurrentVraag: boolean;

  errormessageDecimal: string;
  labelDecimal: string;
  placeholder: string;
  decimalFocus = false;
  decimalHadFocus = false;
  decimalRequired = false;
  resultaten$: Observable<VraagboomAntwoord<IBaseVraagboomResultaat>[]>;
  resultaten: VraagboomAntwoord<IBaseVraagboomResultaat>[];

  get getal(): string {
    return this.resultaat.value;
  }
  set getal(val: string) {
    this.resultaat.value = val ? val.toString() : val;
    if (!this.isCurrentVraag) {
      return;
    }
    this.notifyAntwoord();
  }

  constructor(_dataService: DataService) {
    super(_dataService);
  }

  ngOnInit() {
    if (this.vraag && this.vraag.antwoorden && this.vraag.antwoorden.length > 0) {
      this.errormessageDecimal = this.vraag.antwoorden[0].foutmelding;
      this.labelDecimal = this.vraag.antwoorden[0].titel;
      this.decimalRequired = this.vraag.antwoorden[0].verplicht;
      this.placeholder = this.vraag.antwoorden[0].standaard_waarde_tekst;
    }
  }

  initialize(changes: SimpleChanges): void {
    if (this.antwoordResultaat != null && this.antwoordResultaat.resultaat != null) {
      this.getal = this.antwoordResultaat.resultaat.value;
    } else {
      this.getal = null;
    }

    this.decimalElement.nativeElement.focus();
    this.decimalFocus = true;
    // resultaten ophalen tbv validatie
    this.resultaten$ = this._dataService.resultaten;
    this.resultaten$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(res => {
        if (res !== undefined && res !== null) {
          this.resultaten = res;
        }
      });
  }

  notifyAntwoord() {
    const antwoorden: Antwoord[] = [];
    if (this.vraag && this.vraag.antwoorden && this.vraag.antwoorden.length > 0) {
      antwoorden.push(this.vraag.antwoorden[0]);
    }

    this.setAntwoord(antwoorden, this.resultaat);
  }

  setdecimalFocus(value: boolean) {
    if (!value) {
      this.decimalElement.nativeElement.blur();
      this.decimalHadFocus = true;
    }
  }

  isDecimalLeeg(): boolean {
    return (this.getal == null) || (this.getal.length === 0);
  }

  isDecimalKey($event) {
    const charCode = ($event.which) ? $event.which : $event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      // 44 is komma, 46 is punt
      if (charCode !== 44) {
        return false;
      }
    }
    return true;
  }

  validDecimal(): boolean {
    return NumberValidator.isValidDecimal(this.vraag, this.resultaat, this.resultaten)
      && RegexValidator.isValidRegexAnswer(this.vraag.antwoorden[0], this.resultaat.value);
  }

  validate(vraag: Vraag, antwoorden: Antwoord[], resultaat: VraagboomNumberResultaat): boolean {
    return (antwoorden != null && antwoorden.length === 1) &&
      NumberValidator.isValidDecimal(vraag, resultaat, this.resultaten) &&
      RegexValidator.isValidRegexAnswer(antwoorden[0], resultaat.value);
  }
}
